
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import CurrentBuild from '@/components/Build/CurrentBuild.vue';
import PreviousBuilds from '@/components/Build/PreviousBuilds.vue';

@Component({
  components: { CurrentBuild, PreviousBuilds },
})
export default class BuildManagement extends Vue {
  tabs: number = 0;
}
